import axios from "axios";
import NetworkClient, { ListRequest, ListResponse } from "..";
import Installation, { InstallationStatus } from "../../model/Installation.model";
import InstallationLog from "../../model/InstallationLog.model";
import { DecisionRuleAction, EOperationDirection, FilterGroup, IHsToken, Operation } from "../../store/installation.store";
import { endpoint } from "../api";
import OperationError, { OperationErrorExplaination } from "../../model/OperationError.model";

export const getInstallations = (args: ListRequest): Promise<ListResponse<Installation>> => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .get(endpoint.installations.list(args))
      .then((res: any) => {
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};
export const getInstallation = (id: string): Promise<Installation> => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .get(endpoint.installations.get(id))
      .then((res: any) => {
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};
export const deleteInstallation = (id: string): Promise<Installation> => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .delete(endpoint.installations.delete(id))
      .then((res: any) => {
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

export interface IPayloadNewInstallation {
  id?: string | undefined;
  name?: string | undefined;
  frequency?: number | undefined;
  hsTokens?: IHsToken | undefined;
  state?: InstallationStatus
  realTime?: {
    clientSecret?: string;
  }
}

export interface IHsMe {
  portalId?: string | undefined;
  accountType?: string;
}

export const newInstallation = (data: IPayloadNewInstallation): Promise<IPayloadNewInstallation> => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .post(endpoint.installations.new(), data)
      .then((res: any) => {
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

export const editInstallation = (id: string, data: IPayloadNewInstallation): Promise<IPayloadNewInstallation> => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .patch(endpoint.installations.edit(id), data)
      .then((res: any) => {
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

export const setInstallationRealTimeClientSecret = (installationId: string, clientSecret: string): Promise<Installation> => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .patch(endpoint.installations.edit(installationId), {
        realTime: { clientSecret }
      })
      .then((res: any) => resolve(res?.data))
      .catch((error: any) => reject(error));
  });
}

export const forceStartInstallation = (id: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .post(endpoint.installations.forceStart(id), {})
      .then((res: any) => {
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

export const editHsTokenInstallation = (id: string, code: string, redirectUri: string): Promise<IPayloadNewInstallation> => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .post(endpoint.installations.editHsToken(id), { code, redirectUri: redirectUri })
      .then((res: any) => {
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

export interface IMarketplaceInstallAuthorization {
  redirectUrl: string;
}

export const authorizeMarketplaceInstall = (
  installationId: string,
  returnUrl: string
): Promise<IMarketplaceInstallAuthorization> => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .post(endpoint.installations.authorizeMarketplaceInstall(), { installationId, returnUrl })
      .then((res: any) => resolve(res?.data))
      .catch((error: any) => reject(error));
  });
};

export const getHsInfoInstallation = (id: string): Promise<IHsMe> => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .get(endpoint.installations.getHsInfo(id))
      .then((res: any) => {
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

/** OPERATION */



export interface IPayloadNewOperation {
  installationId: string;
  enabled?: boolean;
  id?: string | undefined;
  name?: string | undefined;
  type: EOperationDirection;
  dbTableName?: string | undefined;
  hsObjectId?: string | undefined;
  transcodingTable?: TranscodingTableItem[];
  decisions?: Decision[];
  associations?: Association[];
  hsWebHookEventConnected?: EHubSpotWebhookEvent | null;
  lastRunAt?: string | null;

}
export interface IPayloadUpdateOperation {
  id?: string | undefined;
  name?: string | undefined;
  type?: EOperationDirection;
  dbTableName?: string | undefined;
  hsObjectId?: string | undefined;
  transcodingTable?: TranscodingTableItem[];
  decisionsAlgorithm?: EDecisionsAlgorithm
  decisions?: Decision[];
  associations?: Association[];
  hsFilterGroups?: FilterGroup[];
  enabled?: boolean;
  hsWebHookEventConnected?: EHubSpotWebhookEvent | null;
}
export enum EDecisionsAlgorithm{
  FUNNEL = "FUNNEL",
  ISOLATE = "ISOLATE"
}
export enum EHubSpotWebhookEvent {
  CREATED = "CREATED",
  DELETED = "DELETED",
  PROPERTY_CHANGED = "PROPERTY_CHANGED",
  MERGE = "MERGE",
  RESTORED = "RESTORED",
  ASSOCIATION_CHANGED = "ASSOCIATION_CHANGED"
}
export interface TranscodingTableItem {
  dbColumnName: string;
  dbColumnDataType: string;
  hsPropertyId: string;
  hsPropertyDataType: string;
  fileNameColumn?: string;
  enabled: boolean;
}
export interface Decision {
  ifBooleanExpressionKey: string;
  thenActionWithZero: DecisionRuleAction;
  thenActionWithOne: DecisionRuleAction;
  thenActionWithMany: DecisionRuleAction;
  enabled: boolean;
}
export interface Association {
  hsDestinationObjectId: string;
  dbFromColumnName: string;
  hsPropertyId: string;
  key?: number;
}



export const newOperation = (data: IPayloadNewOperation): Promise<IPayloadNewOperation> => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .post(endpoint.operations.new(), data)
      .then((res: any) => {
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};


export const updateOperation = (id: string, data: IPayloadUpdateOperation): Promise<IPayloadNewOperation> => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .patch(endpoint.operations.edit(id), {
        ...data,
        ...(data.transcodingTable ? { transcodingTable: (data.transcodingTable || []).filter(table => table.dbColumnName && table.hsPropertyId && table.hsPropertyDataType && table.dbColumnDataType) } : {})
      })
      .then((res: any) => {
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};


export const changeOrderOperation = (id: string, newOrderIndex: number): Promise<IPayloadNewOperation> => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .patch(endpoint.operations.changeOrder(id), {
        index: newOrderIndex
      })
      .then((res: any) => {
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

export const getOperation = (id: string): Promise<Operation> => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .get(endpoint.operations.get(id))
      .then((res: any) => {
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

export const deleteOperation = (id: string) => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .delete(endpoint.operations.delete(id))
      .then((res: any) => {
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};


export const getAllOperationsForInstallationId = (installationId: string): Promise<ListResponse<Operation>> => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .get(endpoint.operations.list({
        limit: 1000,
        skip: 0,
        sort: { id: "orderIndex", direction: "asc" },
        filters: [{ id: "installationId", value: installationId, compare: "equals" }]
      }))
      .then((res: any) => {
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

// PROPERTIES
export interface IHsProperties {
  name: string;
  label: string;
  type: string;
  readOnly?: boolean;
}
export interface IObjectSchema {
  labels: {
    singular: string;
    plural: string;
  };
  name: string;
  objectTypeId: string;
}

export const getAllOPropertiesForInstallationId = (installationId: string, objectTypeId: string): Promise<IHsProperties[]> => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .get(endpoint.installations.hsProperties(installationId, objectTypeId))
      .then((res: any) => {
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};


export const getObjectSchemasForInstallationId = (id: string): Promise<IObjectSchema[]> => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .get(endpoint.installations.objectSchema(id))
      .then((res: any) => {
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

/** LOGS */
export const getInstallationLogs = (id_installation: string, nextToken:string|undefined, args: ListRequest): Promise<{
  nextToken: string | undefined;
  logs:InstallationLog[];
}> => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .get(endpoint.installationLogs.list(id_installation, nextToken, args))
      .then((res: any) => {
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

export const downloadInstallationLogs = (id_installation: string, key_log: string): Promise<void> => {
  function downloadURI(uri: string, name: string) {
    var link = document.createElement("a");
    link.id = `download-link`
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  return new Promise((resolve, reject) => {
    NetworkClient()
      .get(endpoint.installationLogs.download(id_installation, key_log))
      .then((res: any) => {
        downloadURI(res?.data?.url, `${key_log}.log`)
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

/** ERRORS */
export const getOperationErrors = (id_operation: string, args: ListRequest): Promise<ListResponse<OperationError>> => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .get(endpoint.operations.errors.list(id_operation, args))
      .then((res: any) => {
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

export const getOperationErrorExplanations = (id_operation: string, id_execution: string, id_error: string): Promise<OperationErrorExplaination> => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .get(endpoint.operations.errors.aiExplain(id_operation, id_execution, id_error))
      .then((res: any) => {
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};
